<template>
  <div v-loading="meetingSetLoading" class="meeting-set-box">
    <div class="meeting-set-body">
      <div class="body-item">
        <div class="item-title">提醒设置</div>

        <!-- 参会人员不足提醒 -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">参会人数不足提醒:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '在会议召开后' +
                (peopleInsufficient.time || 'N') +
                '分钟，如参与会议不足' +
                (peopleInsufficient.count || 'N') +
                '人，则向代表发送该通知。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <SetSelect
              v-model="peopleInsufficient.time"
              :range="120"
              placeholder="请输入时间"
              suffix="分钟"
              class="input-com-left"
              label="召开前"
            />
            <SetSelect
              v-model="peopleInsufficient.count"
              :range="500"
              placeholder="请输入人数"
              suffix="人"
              label="人数不足"
              type="count"
            />
          </div>
        </div>
        <!-- 入会提醒: -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">入会提醒:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '在会议召开前' +
                (membership.time || 'N') +
                '分钟，发送会议召开提醒，向代表发送该通知。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <SetSelect
              :range="60"
              label="会议前"
              v-model="membership.time"
              placeholder="请输入次数"
              suffix="分钟"
            />
          </div>
        </div>
        <!-- 参会者时间不足提醒: -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">参会者参会时间不足提醒:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '如有参会人参会时间不足' +
                (insufficientReminder.deficiencyTime || 'N') +
                '分钟，则发送该通知。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <!-- <SetSelect
              :range="120"
              placeholder="请输入时间"
              suffix="分钟"
              label="召开后"
              v-model="insufficientReminder.afterConvene"
              class="input-com-left"
            /> -->
            <SetSelect
              v-model="insufficientReminder.deficiencyTime"
              :range="120"
              placeholder="请输入时间"
              suffix="分钟"
              label="时间不足"
            />
          </div>
        </div>
      </div>
      <div class="body-item">
        <div class="item-title">数据展示设置</div>
        <!-- 医生端过往会议展示场次配置: -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">医生端过往会议展示场次配置:</div>
          </div>
          <div class="input-main">
            <el-radio-group v-model="datademonstration.sceneConfiguration">
              <el-radio label="1">过往三场记录</el-radio>
              <el-radio label="2">过往30天记录</el-radio>
              <el-radio label="3">过往365天记录</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 30天内参会超标警示配置： -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">30天内参会超标警示配置：</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '在过去30天内参与会议超过' +
                (datademonstration.warningConfiguration || 'N') +
                '场，则将重点标志该医生。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <InputCom
              v-model="datademonstration.warningConfiguration"
              placeholder="请输入次数"
              suffix="场"
              label="参会次数"
              @change="warningInput"
            />
          </div>
        </div>
      </div>
      <div class="body-item">
        <div class="item-title">关联配置</div>
        <!-- 对会议数据源进行选择和配置 -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">对会议数据源进行选择和配置：</div>
          </div>
          <div class="input-main">
            <el-radio-group v-model="related.config" @change="relatedChange">
              <el-radio label="1">腾讯会议</el-radio>
              <el-radio label="other" disabled>
                <el-radio label="1">腾讯会议</el-radio>
                <el-radio label="other" disabled>其他会议</el-radio>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div v-if="false" class="body-item encryption">
        <div class="item-title">加密开关</div>
        <!-- 对所有会议进行加密，非小程序注册用户不得入会： -->
        <div class="remind-row">
          <div class="lable-title encryption-switch">
            <div class="title-words">对所有会议进行加密，非小程序注册用户不得入会：</div>
          </div>
          <div class="input-main">
            <el-switch v-model="encryption" />
          </div>
        </div>
      </div>
    </div>
    <div class="submit">
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </div>

    <DialogComp
      title1="请填写完整的信息？"
      :title2="'(' + dialogWords + '未填写完整)'"
      :dialog-visible="dialogInfoVisible"
      @dialogEmit="saveInfo"
    />
    <DialogComp
      title2="是否保存填写内容"
      :dialog-visible="dialogWriteVisible"
      @dialogEmit="saveWrite"
    />
    <DialogComp
      title2="即将进入配置页面"
      :dialog-visible="dialogConfigVisible"
      @dialogEmit="openConfigPage"
    />
  </div>
</template>
<script>
import InputCom from '../inputCom';
import SetSelect from '../set-select';
import DialogComp from '@/components/orange-dialog';

export default {
  name: 'MeetingSet',
  components: {
    InputCom,
    DialogComp,
    SetSelect,
  },
  data() {
    return {
      dialogInfoVisible: false, // 不足提醒
      dialogWriteVisible: false, // 保存填写内容
      dialogConfigVisible: false, // 配置页面
      dialogWords: '',
      wenhao:
        'https://eyao-1251316161.cos.ap-guangzhou.myqcloud.com/%25E9%2597%25AE%25E5%258F%25B7%2520%281%29_png_1605666929029.png?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDuc4GCs4H5dwzmItbWL2ViiU0HJ5ds1vc%26q-sign-time%3D1605666929%3B1692066929%26q-key-time%3D1605666929%3B1692066929%26q-header-list%3D%26q-url-param-list%3D%26q-signature%3D0fa70912a3b03199bcce857e90c7de0179f230ef',
      meetingSetLoading: false,
      dialogTitle: '',
      peopleInsufficient: {
        time: '',
        count: '',
      }, // 参会人数不足提醒
      membership: {
        time: '',
      }, // 入会提醒

      insufficientReminder: {
        deficiencyTime: '', // 时间不足
        afterConvene: '', // 召开后
      }, // 时间不足提醒

      datademonstration: {
        sceneConfiguration: '', // 场次配置
        warningConfiguration: '', // 警示配置
      }, // 数据展示

      related: {
        config: '1',
      }, // 关联配置

      encryption: false, // 加密开关
    };
  },
  mounted() {},
  created() {
    this.getMeetingConfig();
  },
  methods: {
    /**
     *获取企业设置配置
     */
    async getMeetingConfig() {
      this.meetingSetLoading = true;
      const res = await this.$requestData('/api/meeting/config/queryAllMeetingConfigInfo', {});
      this.meetingSetLoading = false;
      if (res.data?.code === 0) {
        const data = res.data?.data;
        this.peopleInsufficient.time = data.insufficientAttendanceValue1; // 参会人数不足提醒: //人数
        this.peopleInsufficient.count = data.insufficientAttendanceValue2; // 参会人数不足提醒:  //时间;
        this.membership.time = data.reminderTimeBeforeMeeting; // 入会提醒: 会议开始前，单位分钟
        this.insufficientReminder.deficiencyTime = data.attendMeetInsufficientDuration; // 参会者时间不足提醒
        this.datademonstration.sceneConfiguration = data.doctorViewHistoryType; // 医生端展示过往场次数量配置类型：1:过往三场记录，2:过往30天记录，3:过往365天记录
        this.datademonstration.warningConfiguration = data.doctorAttendanceTimesWarn; // 近30天内参与会议场次超标阈值
        this.related.config = data.meetClientType;
      }
    },
    warningInput(e) {
      const reg = /^[0-9]*$/;
      if (!reg.test(e.trim())) {
        this.datademonstration.warningConfiguration = '';
      }
    },
    /**
     *点击打开完整信息提醒弹窗
     */
    saveInfo(confirm) {
      if (!confirm) {
        this.dialogInfoVisible = false;
        return;
      }

      this.dialogInfoVisible = false;
    },

    /**
     *点击打开进入配置页弹窗
     */
    openConfigPage(confirm) {
      if (!confirm) {
        this.dialogConfigVisible = false;
        return;
      }
    },
    /**
     *选择是否腾讯会议
     */
    relatedChange(e) {
      if (e === 'other') {
        this.dialogConfigVisible = true;
      }
    },
    /**
     *点击提交按钮
     */
    async onSubmit() {
      if (this.verifyParams()) {
        this.dialogWriteVisible = true;
      }
    },
    /**
     *点击打开保存提醒弹窗
     */
    saveWrite(confirm) {
      if (!confirm) {
        this.dialogWriteVisible = false;
        return;
      }

      this.saveMeetingConfig();
      this.dialogWriteVisible = false;
    },
    /**
     *提交验证·
     */
    verifyParams() {
      if (!(this.peopleInsufficient.time && this.peopleInsufficient.count)) {
        this.dialogWords = '参会人数不足提醒';
        this.dialogInfoVisible = true;

        return false;
      }
      if (!this.insufficientReminder.deficiencyTime) {
        this.dialogWords = '参会者参会时间不足提醒';
        this.dialogInfoVisible = true;
        return false;
      }
      return true;
    },

    /**
     *更改企业配置
     */
    async saveMeetingConfig() {
      this.meetingSetLoading = true;

      const params = {
        insufficientAttendanceValue1: this.peopleInsufficient.time, // 参会人数不足提醒: //人数
        insufficientAttendanceValue2: this.peopleInsufficient.count, // 参会人数不足提醒:  //时间;
        reminderTimeBeforeMeeting: this.membership.time, // 入会提醒
        attendMeetInsufficientDuration: this.insufficientReminder.deficiencyTime, // 参会者时间不足提醒
        doctorViewHistoryType: this.datademonstration.sceneConfiguration, // 医生端展示过往场次数量配置类型：1:过往三场记录，2:过往30天记录，3:过往365天记录
        doctorAttendanceTimesWarn: this.datademonstration.warningConfiguration, // 30天警示
        meetClientType: this.related.config, // 会议类型
      };
      const res = await this.$requestData('/api/meeting/config/saveMeetingConfigInfo', params);

      if (res.data?.code === 0) {
        // let data = res.data?.data;
        this.$message.success('保存成功');
        this.getMeetingConfig();
      }
      this.meetingSetLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
